import React from "react";
import AdminHeader from "../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../components/admin/AdminFooter";
import AdminPromptsPageEdit from "../../../views/admin/prompts";
import AdminPromptsList from "../../../views/admin/prompts/list";
import AdminUserCliniciansList from "../../../views/admin/users/list";

const AdminUserCliniciansPageList = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminUserCliniciansList />
      <AdminFooter />
    </div>
  );
};

export default AdminUserCliniciansPageList;
